import React from "react";
var XBold = function XBold(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.3 12.179a0.25 0.25 0 010-0.354l9.263-9.263a1.5 1.5 0 00-2.124-2.121L12.177 9.7a0.25 0.25 0 01-0.354 0L2.561 0.442A1.5 1.5 0 000.439 2.563l9.261 9.262a0.25 0.25 0 010 0.354L0.439 21.442a1.5 1.5 0 002.122 2.121l9.262-9.263a0.25 0.25 0 010.354 0l9.262 9.263a1.5 1.5 0 002.122-2.121z"
  }));
};
XBold.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
import createIconComponent from '../createIconComponent';
export const XBoldIcon = createIconComponent(XBold, 'XBold');